import { computed } from "vue";
import { defineStore } from "pinia";
import { useSelector } from "@xstate/vue";

import { authMachine } from "@/machines/auth-machine";

import { useBrandStore } from "@/stores/brand-store";

import type { UserPermissionName } from "@/machines/auth-machine";

export const useUserPermissionStore = defineStore(
  "userPermission",
  () => {
    const brandStore = useBrandStore();

    const userName = useSelector(authMachine, (snapshot) => snapshot.context.user?.identityProviderId);
    const allPemissions = useSelector(authMachine, (snapshot) => snapshot.context.permissions);

    const userPermission = computed<BrandUserPermission>(() => {
      const { selectedBrand, selectedClient } = brandStore;

      const permissions: Record<string, boolean> = {};

      if (selectedBrand != null && selectedClient != null) {
        // Go through the permissions and get state for current brand and client
        for (const [permissionName, element] of Object.entries(allPemissions.value ?? {})) {
          const permissionState = element?.[selectedClient]?.[selectedBrand];
          if (permissionState == null) continue;

          permissions[permissionName] = permissionState;
        }
      }

      return new Proxy(permissions as BrandUserPermission, {
        set: () => false,
        get: (_, p) => permissions[p as string] ?? false,
      });
    });

    return { userName, userPermission };
  },
  { scope: "global" },
);

type BrandUserPermission = Record<UserPermissionName, boolean>;
